type BadgeNav = Navigator & {
  setAppBadge?: (count?: number) => Promise<void>;
  clearAppBadge?: () => Promise<void>;
};

export async function setStaleBadge(count: number): Promise<void> {
  if (typeof navigator === "undefined") return;
  const nav = navigator as BadgeNav;
  try {
    if (count > 0 && nav.setAppBadge) {
      await nav.setAppBadge(count);
    } else if (nav.clearAppBadge) {
      await nav.clearAppBadge();
    }
  } catch {
    // Badge API isn't granted on this platform; no-op.
  }
}
